/* eslint-disable no-underscore-dangle */
import { createStore, applyMiddleware, compose } from 'redux';
import { thunk } from 'redux-thunk';
import rootReducer from './reducers';
import { createAuthStore } from './Auth';
import env from 'src/env';

const initialState = {};

// Create middleware array - LogRocket middleware disabled due to React 19 compatibility issues
const middleware = [thunk];

export const store = createStore(
  rootReducer(),
  initialState,
  compose(
    applyMiddleware(...middleware),
    window.__REDUX_DEVTOOLS_EXTENSION__ && env.DEPLOY_ENV !== 'production'
      ? window.__REDUX_DEVTOOLS_EXTENSION__ &&
          window.__REDUX_DEVTOOLS_EXTENSION__()
      : (f) => f,
  ),
);

export const authStore = createAuthStore(store);
